import * as React from "react";
import styled from "styled-components";
import { E2EIdentifier } from "../../../core/e2e/E2EIdentifier";
import * as h from "../../../ui/_themes/helpers";

const ELEMENT_ID = "paytableButton";

export enum State {
  DEFAULT,
  ACTIVE,
  DISABLED
}

export interface IPaytableButtonProps {
  className?: string;
  state: State;
  onClick(): void;
}

const View = ({ className, state, onClick }: IPaytableButtonProps) => {
  return (
    <i
      className={className}
      onClick={onClick}
      data-state={state}
      data-e2e-id={E2EIdentifier.KEYPAD_PAYTABLE_BUTTON}
    >
      <svg viewBox="0 0 30 30">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-17.000000, -273.000000)">
            <g transform="translate(17.000000, 273.000000)">
              {state === State.ACTIVE ? (
                <path d="M13.5,22.5 L16.5,22.5 L16.5,13.5 L13.5,13.5 L13.5,22.5 L13.5,22.5 Z M15,0 C6.72,0 0,6.72 0,15 C0,23.28 6.72,30 15,30 C23.28,30 30,23.28 30,15 C30,6.72 23.28,0 15,0 L15,0 Z M13.5,10.5 L16.5,10.5 L16.5,7.5 L13.5,7.5 L13.5,10.5 L13.5,10.5 Z" />
              ) : (
                <path d="M13.5,22.5 L16.5,22.5 L16.5,13.5 L13.5,13.5 L13.5,22.5 L13.5,22.5 Z M15,0 C6.72,0 0,6.72 0,15 C0,23.28 6.72,30 15,30 C23.28,30 30,23.28 30,15 C30,6.72 23.28,0 15,0 L15,0 Z M15,27 C8.385,27 3,21.615 3,15 C3,8.385 8.385,3 15,3 C21.615,3 27,8.385 27,15 C27,21.615 21.615,27 15,27 L15,27 Z M13.5,10.5 L16.5,10.5 L16.5,7.5 L13.5,7.5 L13.5,10.5 L13.5,10.5 Z" />
              )}
            </g>
          </g>
        </g>
      </svg>
    </i>
  );
};

export const PaytableButton = styled(View)`
  display: flex;
  pointer-events: all;
  cursor: pointer;
  border-radius: 50%;

  > svg {
    width: 2.1em;
    height: 2.1em;

    > g > g {
      fill: currentColor;
    }
  }

  &[data-state="${State.DEFAULT}"] {
    > svg {
      color: ${h.getColor(ELEMENT_ID)};
    }
  }

  &[data-state="${State.ACTIVE}"] {
    > svg {
      color: ${h.getActiveColor(ELEMENT_ID)};
    }
  }

  &[data-state="${State.DISABLED}"] {
    > svg {
      color: ${h.getDisabledColor(ELEMENT_ID)};
    }

    pointer-events: none;
  }

  @media (hover: hover) {
    &:hover {
      > svg {
        color: ${h.getHoverColor(ELEMENT_ID)};
      }
    }
  }

  &:active {
    > svg {
      color: ${h.getPressedColor(ELEMENT_ID)};
    }
  }

`;

export const PaytableButtonWrapperForKeypadMobile = styled.div`
  width: 2.9em;
  height: 2.9em;
  align-self: center;

  @media (orientation: landscape) {
    width: 2.2em;
    height: 2.2em;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  background: ${h.getBackgroundColor("keypadIcons", "keypad.icons")};
`;

export const PaytableButtonWrapperForHeaderMobile = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (orientation: landscape) {
    > ${PaytableButton} {
      > svg {
        width: 1.4em;
        height: 1.4em;
      }
    }

    align-self: center;
    margin-top: auto;
  }

  @media (orientation: portrait) {
    display: none;
  }
`;
